type EdgeStrokeStateInput = {
  isActive: boolean;
  isContextMenuActive: boolean;
  isHover: boolean;
  isDropTarget: boolean;
};

export function getEdgeStrokeColor({
  isActive,
  isContextMenuActive,
  isHover,
  isDropTarget
}: EdgeStrokeStateInput): string {
  if (isDropTarget) {
    return '#2563eb';
  }
  if (isActive || isContextMenuActive) {
    return '#3b82f6';
  }
  if (isHover) {
    return '#60a5fa';
  }
  return 'transparent';
}

type VertexFillStateInput = {
  isActive: boolean;
  isHover: boolean;
};

export function getVertexFillColor({
  isActive,
  isHover
}: VertexFillStateInput): string {
  if (isActive) {
    return '#1d4ed8';
  }
  if (isHover) {
    return '#3b82f6';
  }
  return '#2563eb';
}

type Point = { x: number; y: number };

const MIN_HIT_LINE_LENGTH = 4;

export function getInsetEdgeEndpoints(
  p1: Point,
  p2: Point,
  inset: number
): { p1: Point; p2: Point } {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const len = Math.hypot(dx, dy);
  if (len === 0) {
    return { p1, p2 };
  }

  const maxInset = (len - MIN_HIT_LINE_LENGTH) / 2;
  const safeInset = Math.min(inset, Math.max(0, maxInset));
  if (safeInset <= 0) {
    return { p1, p2 };
  }

  const ux = dx / len;
  const uy = dy / len;
  return {
    p1: { x: p1.x + ux * safeInset, y: p1.y + uy * safeInset },
    p2: { x: p2.x - ux * safeInset, y: p2.y - uy * safeInset }
  };
}
